"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatFieldDataListItem_1 = require("./formatFieldDataListItem");
exports.formatFieldData = (type, data, { fieldSchema, schema }) => {
    const nextData = formatFieldDataListItem_1.formatFieldDataListItem(type, data, { fieldSchema, schema });
    return {
        [nextData.type]: nextData.data,
    };
};
//# sourceMappingURL=formatFieldData.js.map